import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'

import { ScrollArea } from 'react-wot-bootstrap'
import IndustrialResource from 'components/IndustrialResource/IndustrialResource.jsx'

import { FORT_BATTLE_SERIES_FINISH_REASONS } from 'constants'
import {
    POSTBATTLE_ROW_HEIGHT,
    POSTBATTLE_HEADER_HEIGHT,
    POSTBATTLE_MAX_ROWS,
} from '../../constants.jsx'
import {
    BATTLE_REWARD,
    SERIES_REWARD,
    TOTAL_REWARD,
    REWARDS,
    POINTS_UNDER_CONTROL,
    ROUND_TITLE,
    TECHNICAL,
    SCROLL_STEP_HEIGHT,
} from './constants.jsx'

import { SERIES_RESULT } from 'helpers/i18n.jsx'

import styles from './Details.scss'

export class Details extends React.Component {

    static propTypes = {
        reward: PropTypes.shape({
            points_under_control: PropTypes.number,
            series: PropTypes.number,
            total: PropTypes.number,
            first_victory_on_direction: PropTypes.number,
            legionary: PropTypes.number,
            requisition: PropTypes.shape({
                percent: PropTypes.number,
                value: PropTypes.number,
            }),
        }).isRequired,
        rounds: PropTypes.array,
        pointsUnderControl: PropTypes.number,
    }

    getLineNode(caption, value, modifier) {
        const listLineClassName = classNames(styles.listLine, {
            [styles[`listLine__${modifier}`]] : modifier,
        })

        const industrialResourceSize = !(modifier === 'grandTotal') ? { small: true } : null

        return (
            <div className={listLineClassName}>
                <div className={classNames(styles.listItem, styles.listItem__caption)}>
                    {caption}
                </div>
                <div className={classNames(styles.listItem, styles.listItem__value)}>
                    <IndustrialResource value={value} {...industrialResourceSize} />
                </div>
            </div>
        )
    }

    render() {
        const { rounds, reward } = this.props

        const seriesResult = (
            <div className={styles.section}>
                <h2 className={styles.header}>{SERIES_RESULT}</h2>
                <div className={styles.list}>
                    {this.getLineNode(
                        POINTS_UNDER_CONTROL[this.props.pointsUnderControl],
                        reward.points_under_control
                    )}
                    {!!reward.first_victory_on_direction &&
                        this.getLineNode(
                            REWARDS.first_victory_on_direction,
                            reward.first_victory_on_direction
                        )
                    }
                    {!!reward.requisition &&
                        this.getLineNode(
                            REWARDS.requisition(reward.requisition.percent),
                            reward.requisition.value
                        )
                    }
                    {!!reward.legionary &&
                        this.getLineNode(
                            REWARDS.legionary,
                            reward.legionary * -1
                        )
                    }
                    {this.getLineNode(
                        SERIES_REWARD,
                        reward.series, 'total'
                    )}

                </div>
            </div>
        )

        const battleResults = this.props.rounds.map((round, idx) => (
            <div className={styles.section} key={`round_${idx + 1}`}>
                <h2 className={styles.header}>{ROUND_TITLE(idx + 1, round.arena.name)}</h2>
                <div className={styles.list}>
                    {this.getLineNode(
                        round.finish_reason !== FORT_BATTLE_SERIES_FINISH_REASONS.TECHNICAL ?
                                 REWARDS.clan_efficiency :
                                 TECHNICAL[round.is_win ? 'VICTORY' : 'DEFEAT'],
                        round.reward.clan_efficiency
                    )}
                    {!!round.reward.artillery_strike &&
                        this.getLineNode(
                            REWARDS.artillery_strike(round.reward.artillery_strike.percent),
                            round.reward.artillery_strike.value
                        )
                    }
                    {!!round.reward.inspiration &&
                        this.getLineNode(
                            REWARDS.inspiration(round.reward.inspiration.percent),
                            round.reward.inspiration.value
                        )
                    }
                    {!!round.reward.airstrike &&
                        this.getLineNode(
                            REWARDS.airstrike(round.reward.airstrike.percent),
                            round.reward.airstrike.value
                        )
                    }
                    {!!round.reward.high_capacity_transport &&
                        this.getLineNode(
                            REWARDS.high_capacity_transport(round.reward.high_capacity_transport.percent),
                            round.reward.high_capacity_transport.value
                        )
                    }
                    {!!round.reward.legionary &&
                        this.getLineNode(
                            REWARDS.legionary,
                            round.reward.legionary * -1
                        )
                    }
                    {
                        this.getLineNode(
                            BATTLE_REWARD,
                            round.reward.total,
                            'total'
                        )
                    }
                </div>
            </div>
        ))

        const rowsMultiplier = rounds.length < POSTBATTLE_MAX_ROWS ? rounds.length : POSTBATTLE_MAX_ROWS
        const scrollableAreaHeight = POSTBATTLE_ROW_HEIGHT * rowsMultiplier + POSTBATTLE_HEADER_HEIGHT

        return (
            <div className={styles.base}>
                <ScrollArea
                    stepHeight={SCROLL_STEP_HEIGHT}
                    scrollableAreaHeight={scrollableAreaHeight}
                    modifier='postbattleDetails'
                >
                    <div className={styles.content}>
                        {seriesResult}
                        {battleResults}
                        <div className={styles.section}>
                            {this.getLineNode(TOTAL_REWARD, reward.total, 'grandTotal')}
                        </div>
                    </div>
                </ScrollArea>
            </div>
        )
    }
}



export default Details



// WEBPACK FOOTER //
// ./containers/PostbattleScreen/components/Details/Details.jsx